export default function getFileType(filename) {
  if (!filename || typeof filename !== 'string') return null;

  const ext = filename.split('.').pop().toLowerCase();

  const types = {
    image: ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg', 'avif'],
    video: ['mp4', 'webm', 'mov', 'avi', 'mkv'],
    audio: ['mp3', 'wav', 'ogg', 'aac'],
    document: ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'],
    text: ['txt', 'csv', 'json', 'xml'],
    archive: ['zip', 'rar', '7z', 'tar', 'gz'],
  };

  for (const [type, extensions] of Object.entries(types)) {
    if (extensions.includes(ext)) {
      return type;
    }
  }

  return 'unknown';
}
